<template>
  <hm-content title="收银设置" class="wakeup-setting">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="导购每日积分上限：" prop="integralUpperLimit">
        <el-input
          style="width: 100px"
          size="small"
          @mousewheel.prevent.native
          clearable
          type="number"
          @input="filterGt0('integralUpperLimit')"
          v-model.trim="ruleForm.integralUpperLimit"
        ></el-input>
        积分
      </el-form-item>
      <el-form-item label="导购奖励：" prop="integralFirst">
        <el-input
          style="width: 100px"
          size="small"
          @mousewheel.prevent.native
          clearable
          type="number"
          @input="filterGt0('integralFirst')"
          v-model.trim="ruleForm.integralFirst"
        ></el-input>
        积分
      </el-form-item>
      <el-form-item label="会员每次购物返还导购奖励：" prop="integralReturn">
        <el-input
          style="width: 100px"
          size="small"
          @mousewheel.prevent.native
          clearable
          type="number"
          v-model.trim="ruleForm.integralReturn"
        ></el-input>
        %<span class="form-tip"
          >（每次门店购物时获得的积分奖励，按照购物商品金额的百分比获得）</span
        >
      </el-form-item>
      <el-form-item label="公共会员定义：" prop="definition">
        <div>
          超过<el-input
            style="width: 100px; margin: 0 20px"
            size="small"
          @input="filterGt0('maxShoppingDay')"
            @mousewheel.prevent.native
            clearable
            type="number"
            v-model.trim="ruleForm.maxShoppingDay"
          ></el-input
          >天未购物的会员定义为公共会员
        </div>
        <div class="second-line">
          联系过的公共会员，但会员超过<el-input
            style="width: 100px; margin: 0 20px"
            size="small"
          @input="filterGt0('validContactDay')"
            @mousewheel.prevent.native
            clearable
            type="number"
            v-model.trim="ruleForm.validContactDay"
          ></el-input
          >天未购物的会员定义为公共会员
        </div>
      </el-form-item>
      <el-form-item label="唤醒状态：" prop="handover">
        <el-switch
          v-model="ruleForm.status"
          size="mini"
            active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="open"
          active-text="开启"
          inactive-text="关闭"
          inactive-value="close"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="save('ruleForm')"
            >保存</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </hm-content>
</template>

<script>
 
 import { mapGetters } from 'vuex'
export default {
  name: "cahierSetting",
    
  data() {
    const validatorFunc = function(rule, val, callback) {
      if (!this.ruleForm.maxShoppingDay) {
        return callback(new Error("请输入超过期限"));
      } else if (!this.ruleForm.validContactDay) {
        return callback(new Error("请输入联系后超过期限"));
      } else {
        callback();
      }
    }.bind(this);
    return {
      ruleForm: {
        integralUpperLimit: '',
        integralFirst: '',
        integralReturn: '',
        maxShoppingDay: '',
        validContactDay: '',
        status: ''
      },
      rules: {
        integralUpperLimit: {
          required: true,
          trriger: 'blur',
          message: '请输入每日积分上限'
        },
        integralFirst: {
          required: true,
          trriger: 'blur',
          message: '请输入导购奖励积分'
        },
        integralReturn: {
          required: true,
          trriger: 'blur',
          message: '每次返还导购奖励'
        },
        definition:  {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
      }
    };
  },
  computed: mapGetters(['wakeUpConfig']),
  created() {
    this.$store.dispatch("showWakeUpConfig");
  },
  watch: {
    wakeUpConfig(val) {
      if (val) {
        Object.keys(val).map(key => {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = val[key]
          }
        })
      }
    }
  },
  methods: {
    filterGt0(key) {
      this.ruleForm[key] = this.ruleForm[key].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[key] = this.ruleForm[key].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[key] = this.ruleForm[key]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[key] = this.ruleForm[key].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
    },
    save() {
      this.$store
        .dispatch("editWakeUpConfig", this.ruleForm)
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
          }
        });
    }
  }
};
</script>
<style lang="scss">
.wakeup-setting {
  .el-form-item__label {
    width: 214px !important;
  }
}
</style>
<style lang="scss" scoped>
.second-line {
  padding-left: 113px;
}
</style>
